module.exports = __webpack_public_path__ + "img/Middle-Vertical-Rectangular-Attachment-12.6889c614.png";